const V = (import.meta as any).env || {};
export const restBaseUrl = V?.VITE_API_URL || V?.VITE_API_BASE_URL || "http://localhost:8001";

async function http<T>(url: string, init?: RequestInit): Promise<T> {
  const res = await fetch(url, {
    ...init,
    headers: {
      "Content-Type": "application/json",
      ...(init?.headers || {}),
    },
  });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(`${res.status}: ${text}`);
  }
  return res.json();
}

export const api = {
  // Generic methods
  get: <T = any>(url: string) => http<T>(`${restBaseUrl}/api/v1${url}`),
  post: <T = any>(url: string, data?: any) => http<T>(`${restBaseUrl}/api/v1${url}`, { 
    method: "POST", 
    body: data ? JSON.stringify(data) : undefined 
  }),
  patch: <T = any>(url: string, data?: any) => http<T>(`${restBaseUrl}/api/v1${url}`, { 
    method: "PATCH", 
    body: data ? JSON.stringify(data) : undefined 
  }),
  delete: <T = any>(url: string) => http<T>(`${restBaseUrl}/api/v1${url}`, { method: "DELETE" }),
  
  // Specific methods (legacy)
  listReviews: (params: URLSearchParams) => http<{ items: any[]; total: number }>(`${restBaseUrl}/api/v1/reviews?${params.toString()}`),
  getReview: (id: string) => http<{ review: any; responses: any[] }>(`${restBaseUrl}/api/v1/reviews/${id}`),
  createResponse: (review_id: string, overrides?: { style?: string; recommend?: string; send_after?: string }) =>
    http<any>(`${restBaseUrl}/api/v1/responses`, { method: "POST", body: JSON.stringify({ review_id, ...(overrides || {}) }) }),
  approveResponse: (id: string) => http<any>(`${restBaseUrl}/api/v1/responses/${id}/approve`, { method: "POST" }),
  rejectResponse: (id: string, notes?: string) => http<any>(`${restBaseUrl}/api/v1/responses/${id}/reject`, { method: "POST", body: JSON.stringify({ notes }) }),
  publishResponse: (id: string) => http<any>(`${restBaseUrl}/api/v1/responses/${id}/publish`, { method: "POST" }),
  patchResponse: (id: string, body: any) => http<any>(`${restBaseUrl}/api/v1/responses/${id}`, { method: "PATCH", body: JSON.stringify(body) }),
};
